import type { QueryParams } from "../types/api";

const buildQueryString = (params?: QueryParams): string => {
  const query = new URLSearchParams();
  if (!params) return query.toString();

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== undefined && item !== null) {
          query.append(key, String(item));
        }
      }
    } else {
      query.set(key, String(value));
    }
  }

  return query.toString();
};

export { buildQueryString };
